import { QueryFunctionContext } from '@tanstack/react-query';
import { MerchantOrchestrationService } from 'src/services/MerchantOrchestrationService';

export const QUERY_KEY = 'availableLocales';

export type AvailableLocalesQueryKey = [
    typeof QUERY_KEY,
    string | undefined | false,
    {
        productKey: string;
        productVersion: number;
    }
];

export const queryAvailableLocales = (
    context: QueryFunctionContext<AvailableLocalesQueryKey>,
): Promise<string[]> => {
    const { queryKey } = context;
    const [, accessToken, { productKey, productVersion }] = queryKey;

    if (!accessToken || typeof accessToken !== 'string') {
        return Promise.resolve([]);
    }

    return MerchantOrchestrationService.getAvailableLocales(
        accessToken,
        productKey,
        productVersion,
    );
};
